import axios from 'src/utils/axios';

class AnnouncementsApi {
  async getAnnouncements() {
    const response = await axios.get(`/client/client_account/announcements`);
    return response;
  }

  async updateAnnouncement(data = {}) { 
    const response = await axios.put(`/client/client_account/announcements/${data?.setting_id}/update_status`, { params: data });
    return response;
  }
}

export const announcementsApi = new AnnouncementsApi();
